/** Fixed-size ring buffer of numbers, oldest first. */
export class Ring {
  private readonly buf: Float64Array;
  private start = 0;
  length = 0;

  constructor(readonly capacity: number) {
    this.buf = new Float64Array(capacity);
  }

  push(v: number) {
    if (this.length < this.capacity) this.buf[(this.start + this.length++) % this.capacity] = v;
    else {
      this.buf[this.start] = v;
      this.start = (this.start + 1) % this.capacity;
    }
  }

  /** i = 0 is the oldest entry. */
  get(i: number): number {
    return this.buf[(this.start + i) % this.capacity];
  }

  clear() {
    this.start = 0;
    this.length = 0;
  }
}

/** Per-run statistics shown on the HUD. */
export class RunStats {
  jumps = 0;
  /** Takeoff speed of the last 7 jumps, rounded. */
  readonly jumpSpeeds = new Ring(7);
  syncGood = 0;
  syncTotal = 0;
  /** Horizontal speed of the last 12 ticks (HUD gain/loss colour). */
  readonly speedHist = new Ring(12);

  reset() {
    this.jumps = 0;
    this.jumpSpeeds.clear();
    this.syncGood = 0;
    this.syncTotal = 0;
  }

  get syncPercent(): number {
    return this.syncTotal ? Math.round((100 * this.syncGood) / this.syncTotal) : 0;
  }
}
